export default __webpack_public_path__ + "static/media/modal-close.a1d1a7a0.svg";